import { useContext, useState } from 'react';
import {
  Typography,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  MenuItem,
} from '@mui/material';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '../../../../../components/common/Accordion';
import {
  TableRow as StyledTableRow,
  TableCell as StyledTableCell,
} from '../../../../../components/common/Table';
import {
  Grid,
  Button,
  TextField,
  CustomInput,
} from '../../../../../components/common';
import colors from '../../../../../assets/colors';
import { animalTypes } from '../../../../../assets/consts';
import AccordionFormContext from '../../../../../store/accordion-form-context';

export default function AnimalProduction() {
  const accordionCTX = useContext(AccordionFormContext);
  const [animalProductionType, setAnimalProductionType] = useState('');
  const [animalProductionAmount, setAnimalProductionAmount] = useState('');

  const handleAddNewAnimalProduction = () => {
    accordionCTX.changeFormValue('animalProductionRequestList', [
      ...accordionCTX.form.animalProductionRequestList,
      {
        name: animalProductionType,
        livestockAmount: parseInt(animalProductionAmount),
      },
    ]);
    setAnimalProductionAmount('');
    setAnimalProductionType('');
  };

  const handleAnimalProductionSelectChange = (event) => {
    setAnimalProductionType(event.target.value);
  };

  const handleAnimalProductionAmountChange = (event) => {
    setAnimalProductionAmount(event.target.value);
  };

  return (
    <Accordion
      square
      expanded={accordionCTX.navigation.expanded === 'panel4'}
      onChange={() => accordionCTX.changeNavigation('CHANGE', 'panel4')}
    >
      <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
        <h1>4. Produkcja zwierzęca</h1>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          <Grid
            infoCard
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            component={Paper}
          >
            <Typography variant="h4">
              Poniżej możesz dodać źródła dochodu pochodzące z produkcji
              zwierzęcej gospodarstwa
            </Typography>
          </Grid>
          <Grid
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="left">
                      Nazwa produkcji zwierzęcej
                    </StyledTableCell>
                    <StyledTableCell align="left">Ilość sztuk</StyledTableCell>
                    <StyledTableCell align="right" />
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {accordionCTX.form.animalProductionRequestList.map(
                    (row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row">
                          {row.name}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.livestockAmount} sztuk
                        </StyledTableCell>
                        <StyledTableCell
                          component="th"
                          scope="row"
                          align={'right'}
                        >
                          <Button
                            onClick={() => {
                              let array = [
                                ...accordionCTX.form
                                  .animalProductionRequestList,
                              ];
                              array.splice(index, 1);
                              accordionCTX.changeFormValue(
                                'animalProductionRequestList',
                                array
                              );
                            }}
                            variant="contained"
                          >
                            Usuń produkcję zwierzęcą
                          </Button>
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid
            topMargin
            container
            justifyContent="center"
            alignItems="top"
            direction={'row'}
            spacing={2}
          >
            <Grid item xs={12} md={5}>
              <TextField
                bordered
                select
                variant="outlined"
                fullWidth
                label="Wybierz typ produkcji zwierzęcej"
                value={animalProductionType}
                sx={{
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: colors.oldAgroweGreen,
                    color: colors.black,
                  },
                  '& .MuiOutlinedInput-input': {
                    color: colors.black,
                  },
                }}
                onChange={handleAnimalProductionSelectChange}
                input={<CustomInput />}
              >
                {animalTypes.map((type) => (
                  <MenuItem value={type} key={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                variant="outlined"
                margin="normal"
                value={animalProductionAmount}
                required
                fullWidth
                id="animalProductionAmount"
                type="number"
                label={
                  animalProductionType.length === 0
                    ? 'Podaj liczbę zwierząt'
                    : animalProductionType === 'Krowy mleczne' ||
                      animalProductionType === 'Kury nioski'
                    ? 'Podaj liczbę trzymanych sztuk'
                    : 'Podaj liczbę sztuk sprzedawanych rocznie'
                }
                name="animalProductionAmount"
                onChange={handleAnimalProductionAmountChange}
                error={parseInt(animalProductionAmount) <= 0}
                helperText={
                  parseInt(animalProductionAmount) <= 0 &&
                  'Tylko wartości większe od 0'
                }
                sx={{ mt: 0 }}
              />
            </Grid>
            <Grid topMargin item xs={12} md={2}>
              <Button
                variant="contained"
                sx={{ mt: -3 }}
                disabled={
                  animalProductionAmount.length === 0 ||
                  animalProductionType.length === 0 ||
                  parseInt(animalProductionAmount) <= 0
                }
                onClick={handleAddNewAnimalProduction}
              >
                Dodaj
              </Button>
            </Grid>
          </Grid>
          <Grid topMargin container justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              onClick={() => accordionCTX.changeNavigation('UNLOCK', 'panel5')}
            >
              Akceptuję przychody z produkcji zwierzęcej, chcę przejść dalej
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
